import { useMutation } from '@apollo/client'
import {
  EditInsuranceCompany,
  EditInsuranceCompanyVariables,
  EditInsuranceCompanyInput,
} from '../../types'
import { EDIT_INSURANCE_COMPANY } from './operations'

interface EditInsuranceCompanyProps {
  onCompleted?: () => void
  filter?: EditInsuranceCompanyInput
}

export const useEditInsuranceCompany = ({ onCompleted }: EditInsuranceCompanyProps) =>
  useMutation<EditInsuranceCompany, EditInsuranceCompanyVariables>(EDIT_INSURANCE_COMPANY, {
    onCompleted,
  })
